module.exports = __webpack_public_path__ + "static/2001-09-15_17.23.51-c00ab4b4e980277873e03eff947b7658.jpg";